import React from "react";
import { IBunkerEthaneTableRow } from "redux/app/vdmdashboard/@types";

type OwnProps = {
	tableData: IBunkerEthaneTableRow[];
};

function EthaneFuelTable(props: OwnProps) {
	const { tableData } = props;
	return (
		<div className="p-4 bg-white rounded-lg overflow-x-auto">
			<div className="overflow-x-auto border border-b-none border-gray-300 rounded ws-scroll">
				<table className="min-w-full overflow-x-auto divide-y divide-gray-200">
					<thead className="bg-gray-50 text-gray-600">
						<tr>
							<th
								rowSpan={2}
								className="px-3 py-2 text-left text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Tank Type
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Capacity (m3)
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Cargo / Heel ROB (m3)
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Fuel ROB (m3)
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Volume (%)
							</th>
							<th
								colSpan={3}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Temperature °C
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Pressure (bar g)
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Density (kg/m3)
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Last Bunker Location
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap border-r"
							>
								Last Bunker Date
							</th>
							<th
								rowSpan={2}
								className="px-3 py-2 text-sm font-medium w-full whitespace-nowrap"
							>
								Status
							</th>
						</tr>
						<tr>
							<th className="text-sm py-2 font-medium border-r border-t">
								Top
							</th>
							<th className="text-sm py-2 font-medium border-r border-t">
								Mid
							</th>
							<th className="text-sm py-2 font-medium border-r border-t">
								Bottom
							</th>
						</tr>
					</thead>
					<tbody className="bg-white">
						{tableData?.map((tank, idx) => (
							<tr key={idx} className="border-b last:border-0">
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.tankType}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.capacity}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.cargo}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.fuelROB}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									<div className="flex items-center gap-2">
										<div className="w-20 h-2 rounded bg-gray-200">
											<div
												className="h-2 bg-green-500 rounded"
												style={{ width: `${tank.volume}%` }}
											></div>
										</div>
										<span className="text-xs font-mono">{tank.volume}%</span>
									</div>
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.tempTop}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.tempMid}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.tempBottom}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.pressure.toFixed(2)}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.density}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									{tank.bunkerLoc}
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap border-r">
									<span className="px-2 py-1 text-xs rounded-lg bg-green-100 text-green-600 font-medium flex items-center">
										<span className="h-1 w-1 bg-green-600 rounded-full mr-1" />
										<span>{tank.bunkerDate}</span>
									</span>
								</td>
								<td className="px-3 py-2 text-sm whitespace-nowrap">
									<span className="px-2 py-1 text-xs rounded-lg bg-blue-100 text-blue-700 font-medium flex items-center">
										<span className="h-1 w-1 bg-blue-500 rounded-full mr-1" />
										<span>{tank.status}</span>
									</span>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default EthaneFuelTable;
